import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Zonas from './pages/Zonas';
import Colmenas from './pages/Colmenas';
import Colmena from './pages/Colmena';
import Tareas from './pages/Tareas';
import Bitacora from './pages/Bitacora';
import Clima from './pages/Clima';
import Ajustes from './pages/Ajustes';
import Campo from './pages/Campo';
import AccionesLote from './pages/AccionesLote';
import Temporada from './pages/Temporada';
import Layout from './components/Layout';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  return user ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  return user ? <Navigate to="/" /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="zonas" element={<Zonas />} />
            <Route path="colmenas" element={<Colmenas />} />
            <Route path="colmenas/:id" element={<Colmena />} />
            <Route path="tareas" element={<Tareas />} />
            <Route path="bitacora" element={<Bitacora />} />
            <Route path="clima" element={<Clima />} />
            <Route path="ajustes" element={<Ajustes />} />
            <Route path="campo" element={<Campo />} />
            <Route path="lote" element={<AccionesLote />} />
            <Route path="temporada" element={<Temporada />} />
            {/* Estado y Timeline se fusionaron en Colmenas y en la ficha de colmena.
                Sus direcciones antiguas siguen vivas para no romper marcadores. */}
            <Route path="estado" element={<Navigate to="/colmenas" replace />} />
            <Route path="timeline" element={<Navigate to="/colmenas" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
